@if (currentSelectedRundown()) {
    @if (currentRundownSelectedStory()) {
        <st-story-full-screen
            standaloneStory
            [data]="currentRundownSelectedStory()"
            [sidecarMenu]="sidecarMenu()" />
        <div class="st-rundown-list-sidecar-pager">
            <button
                mat-icon-button
                class="st-rundown-list-sidecar-pager-button-first"
                (click)="navigate(NavigationDirection.FIRST)">
                <mat-icon>first_page</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-list-sidecar-pager-button-previous"
                (click)="navigate(NavigationDirection.PREVIOUS)">
                <mat-icon>navigate_before</mat-icon>
            </button>
            <span class="st-rundown-list-sidecar-pager-text">Story {{ indexInParentToShow() }} of {{ totalCount() }}</span>
            <button
                mat-icon-button
                class="st-rundown-list-sidecar-pager-button-next"
                (click)="navigate(NavigationDirection.NEXT)">
                <mat-icon>navigate_next</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rundown-list-sidecar-pager-button-last"
                (click)="navigate(NavigationDirection.LAST)">
                <mat-icon>last_page</mat-icon>
            </button>
        </div>
    } @else {
        <st-rundown-full-screen
            [data]="currentSelectedRundown()"
            [layout]="roLayout()"
            [fullscreenArea]="this.sidecarMenu()"
            (layoutChange)="changeRoLayout($event, currentSelectedRundown().Guid)"
            (storyOpen)="openStory($event)" />
    }
} @else {
    <div class="st-rundown-list-sidecar-label">{{ rundownsLabel$ | ngrxPush }}</div>
    <div class="st-rundown-list-sidecar__grid">
        <mat-button-toggle-group
            class="st-rundown-list-sidecar-buttons-group"
            [value]="selectedListSearchType()"
            (change)="toggleSearchTab($event)">
            <mat-button-toggle
                class="st-rundown-list-sidecar-buttons-group__search"
                [value]="SearchType.SEARCH">
                {{ languageSettings.PSTWebCastSearchTabLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-rundown-list-sidecar-buttons-group__views"
                [value]="SearchType.SAVED">
                {{ languageSettings.PSTWebSavedViewsTabLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="st-rundown-list-sidecar__grid__right">
            @if (savedViewDropdownVisible()) {
                <mat-form-field
                    class="st-rundown-list-sidecar__views-dropdown"
                    subscriptSizing="dynamic">
                    <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>
                    <mat-select
                        [value]="currentViewState()?.Guid"
                        [placeholder]="languageSettings.PSTWebSavedViewsLabel"
                        (selectionChange)="onViewStateGuidChanged($event)">
                        @for (item of selectSavedViewStates(); track item.Guid) {
                            <mat-option [value]="item.Guid">
                                {{ item.Title }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <div class="st-rundown-list-sidecar__search-bar">
                    <!-- <st-simple-search-box
          st-click-stop-propagation
          class="st-rundown-list-sidecar__search-bar__search"
          (searchThermChange)="onSearchHandler($event)" /> -->
                    <st-simple-search-box-autocomplete
                        st-click-stop-propagation
                        class="st-cast-objects-list__search-bar__search"
                        (searchExecute)="onSearchHandler($event)" />
                </div>
            }
        </div>
    </div>
    @if (!rundowns()?.length) {
        <div class="st-rundown-list-sidecar-text">
            {{ 'Sorry, there are no results matching your criteria' }}
        </div>
    } @else {
        <div class="st-rundown-list-sidecar-condensed-view">
            <cdk-virtual-scroll-viewport
                class="st-rundown-list-sidecar-condensed-view-port"
                itemSize="60">
                <ng-container *cdkVirtualFor="let ro of rundowns(); let isLast = last">
                    <div
                        class="st-rundown-list-sidecar-condensed-item"
                        (click)="openRundown(ro)">
                        <div
                            class="st-rundown-list-sidecar-condensed-item-border-left"
                            st-left-border
                            [data]="ro"></div>
                        <div class="st-rundown-list-sidecar-condensed-item-container">
                            <mat-icon fontSet="material-symbols-outlined">dns</mat-icon>
                            <div class="st-rundown-list-sidecar-condensed-item-container-static">
                                <div class="st-rundown-list-sidecar-condensed-item-container-static__title">{{ ro?.Title }}</div>
                                <!-- -->
                                <div class="st-rundown-list-sidecar-condensed-item-container-static__start-time">{{ ro?.ModTimeDisplay }}</div>
                            </div>
                        </div>
                    </div>
                    @if (!isLast) {
                        <mat-divider class="st-rundown-list-sidecar-condensed-item-divider" />
                    }
                </ng-container>
            </cdk-virtual-scroll-viewport>
        </div>
    }
}
